export default "__VITE_ASSET__DwggzgHG__"